import Choices from 'choices.js';

export const choicesConfig = {
  searchEnabled: true,
  removeItemButton: true,
  itemSelectText: '',
  position: 'bottom',
};

if (window.sfp.lang === '0') {
  choicesConfig.noChoicesText = 'Keine Optionen zur Auswahl';
}

$('.CustomSelect select:not(.ApartmentFilter)').each((i, e) => {
  const choices = new Choices(e, choicesConfig);

  e.addEventListener('change', (event) => {
    choices.hideDropdown();
    window.location.href = event.detail.value;
  });
});
